import { PLATFORM_TRAINER_EXAMPLE_SCENARIO } from "@/lib/training/roleplayPlatformExample";
import type { RoleplayScore } from "@/lib/training/trainingApiClient";

export const RATING_OPTS = [1, 2, 3, 4, 5] as const;

export function scenarioLabel(key: string): string {
  if (key === PLATFORM_TRAINER_EXAMPLE_SCENARIO.key) return PLATFORM_TRAINER_EXAMPLE_SCENARIO.label;
  return key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function isRoleplayScore(s: unknown): s is RoleplayScore {
  if (!s || typeof s !== "object") return false;
  const o = s as Record<string, unknown>;
  if (typeof o.overallScore !== "number") return false;
  const hasNew =
    typeof o.answersCustomerQuestions === "number" ||
    typeof o.usesFollowUpQuestions === "number" ||
    typeof o.usesOpenEndedQuestions === "number";
  const hasLegacy = typeof o.empathy === "number";
  return hasNew || hasLegacy;
}

/** Display helper: tolerate legacy scores that only had empathy/objections. */
export function roleplayScoreLine(ai: RoleplayScore): string {
  const fmt = (n: number | undefined) => (typeof n === "number" && !Number.isNaN(n) ? n.toFixed(1) : "—");
  const leg = ai.empathy;
  const ac = ai.answersCustomerQuestions ?? leg;
  const fq = ai.usesFollowUpQuestions ?? leg;
  const oe = ai.usesOpenEndedQuestions ?? leg;
  return `Overall ${fmt(ai.overallScore)} — clarity ${fmt(ai.clarity)}, accuracy ${fmt(ai.accuracy)}, answers customer ${fmt(ac)}, follow-ups ${fmt(fq)}, open-ended ${fmt(oe)}, concerns ${fmt(ai.objectionHandling ?? leg)}`;
}
